export default __webpack_public_path__ + "static/media/KanandaFerreira_02.d057138d.jpg";